export const formatSlashCaseToDash = (path: string) =>
  path.replace('/', '').replace(/\/|_/g, '-')
